import React, { useState } from 'react';
import LoadingSpinner from '../Common/LoadingSpinner.js';
import { trackEvent } from '../../services/analytics.js';

const CvrForm = ({ onSubmit, loading, error }) => {
    const [cvr, setCvr] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        onSubmit({ cvr: cvr.replace(/\s/g, '') });

        // Track CVR lookup event
        trackEvent('cvr_lookup', {
            cvr_number: cvr.replace(/\s/g, ''),
            success: true
        });
    };

    return (
        <form onSubmit={handleSubmit} className="mt-8">
            <div>
                <label 
                    htmlFor="cvr" 
                    className="block text-sm font-medium text-gray-700 mb-2"
                >
                    CVR Nummer
                </label>
                <div className="relative rounded-md shadow-sm">
                    <input
                        id="cvr"
                        name="cvr"
                        type="text"
                        required
                        pattern="\d{8}"
                        maxLength="8"
                        placeholder="12345678"
                        className="block w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light text-gray-900 text-lg"
                        value={cvr}
                        onChange={(e) => setCvr(e.target.value.replace(/\D/g, '').slice(0, 8))}
                    />
                </div>
                {error && (
                    <p className="mt-2 text-sm text-red-600">{error}</p>
                )}
            </div>

            <button
                type="submit"
                disabled={loading}
                className="w-full mt-4 flex justify-center py-3 px-6 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-brand-dark hover:bg-brand-dark/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-light disabled:opacity-50 transition-colors duration-200"
            >
                {loading ? <LoadingSpinner /> : 'Søg'}
            </button>
        </form>
    );
};

export default CvrForm;